import React from "react";
import SidebarCloseButton from "../SidebarCloseButton";
import useSidebarBar from "./hooks/useSidebarBar";
import { BaseSidebarBar, BaseSidebarContent } from "./styled";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function SidebarBar(_ref) {
  var isOpen = _ref.isOpen,
    children = _ref.children,
    closeSidebar = _ref.closeSidebar,
    topOffset = _ref.topOffset;
  var _useSidebarBar = useSidebarBar(topOffset),
    style = _useSidebarBar.style;
  return /*#__PURE__*/_jsx(BaseSidebarBar, {
    isOpen: isOpen,
    css: style,
    children: /*#__PURE__*/_jsxs(BaseSidebarContent, {
      children: [/*#__PURE__*/_jsx(SidebarCloseButton, {
        tooltipContent: "Close Sidebar",
        onClick: closeSidebar
      }), children]
    })
  });
}
export default SidebarBar;